/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_1_DescInputs */

const en_mk_start_1_desc = /** @type {(inputs: Mk_Start_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google or a code sent to your work email. Name the company, tick the divisions you want to try, done.`)
};

const id_mk_start_1_desc = /** @type {(inputs: Mk_Start_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk dengan Google atau kode yang dikirim ke email kerja. Beri nama perusahaan, centang divisi yang ingin dicoba, selesai.`)
};

/**
* | output |
* | --- |
* | "Sign in with Google or a code sent to your work email. Name the company, tick the divisions you want to try, done." |
*
* @param {Mk_Start_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_1_desc = /** @type {((inputs?: Mk_Start_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_1_desc(inputs)
	return en_mk_start_1_desc(inputs)
});